import app from 'flarum/forum/app';
import addTagFilter from './addTagFilter';
import addTagLabels from './addTagLabels';
import addTagControl from './addTagControl';
import addTagComposer from './addTagComposer';
import extendRealtime from './extendRealtime';
import addLabelSearch from './addLabelSearch';
export { default as extend } from './extend';
app.initializers.add('nightash-labels', () => {
  addLabelSearch();
  addTagFilter();
  addTagLabels();
  addTagControl();
  addTagComposer();

  // Register a discussion stream update event with flarum/realtime when enabled.
  // Tag changes will trigger a DiscussionPage stream reload for other users.
  if ('flarum-realtime' in flarum.extensions) {
    extendRealtime();
  }
});
import './forum';